import shared from './shared'

export default {
    shared,
    async resetFirebaseQuiz (inSeconds, quizId, endIn) {
        if (!inSeconds) {
            inSeconds = 3
        }
        if (!quizId) {
            quizId = 46
        }
        if (!endIn) {
            endIn = 60 * 10
        }
        let q48 = this.shared.db().ref(`/quizess/${quizId}`)
        await q48.child('startTime').set(Math.round(Date.now() / 1000) + inSeconds)
        await q48.child('endTime').set(Math.round(Date.now() / 1000) + endIn + inSeconds)
    }
}
